import { Skeleton } from "antd";
import styles from "../../../styles/Components/new-dashboard/DashboardLoaders.module.css";

function BotPerformanceLoader() {
  return (
    <>
      <Skeleton active paragraph={{ rows: 1 }} />
      <div className={styles.performanceLoader}>
        {Array.from(Array(4).keys()).map((_, i) => (
          <Skeleton.Node active key={i} />
        ))}
      </div>
    </>
  );
}

export default BotPerformanceLoader;
